import { PageLayout, SuspenseWithSentryErrorBoundary } from '@retail/components';
import { MgSupplierItemSearchPageContainer } from '@retail/products/containers';
import { AddCheckedItemsToAssortment } from '@retail/my-assortment/containers';
import { Paper } from '@mui/material';
import { useSelectedOrgUnit } from '@retail/app/stores/selected-context';

export function MgSupplierItemSearchPage() {
  const { assortmentId } = useSelectedOrgUnit();

  return (
    <PageLayout maxWidth="full" fixedHeight spacing={2}>
      <Paper
        sx={{ display: 'flex', flexDirection: 'column', height: '100%', pt: 2, overflow: 'hidden' }}
      >
        <SuspenseWithSentryErrorBoundary>
          <MgSupplierItemSearchPageContainer
            assortmentId={assortmentId}
            renderAddItemsDialog={({ selectedItems, onClose }) => (
              <AddCheckedItemsToAssortment
                open
                assortmentId={assortmentId}
                selectedItems={selectedItems}
                onClose={onClose}
              />
            )}
          />
        </SuspenseWithSentryErrorBoundary>
      </Paper>
    </PageLayout>
  );
}
